/* eslint-disable import/prefer-default-export */

const ACTION_GET_USER = 'GET_USER'
const ACTION_GET_NOTIFICATION = 'GET_NOTIFICATION'

const ACTION_GET_COURSES = 'GET_MASTER_COURSES'
const ACTION_GET_APPLICATIONS = 'GET_MASTER_APPLICATIONS'
const ACTION_GET_METRICS = 'GET_MASTER_METRICS'

export {
  ACTION_GET_USER,
  ACTION_GET_NOTIFICATION,

  ACTION_GET_COURSES,
  ACTION_GET_APPLICATIONS,
  ACTION_GET_METRICS,
}



// WEBPACK FOOTER //
// ./client/masteradmin/store/actions.js